function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 1,
  y1: 1.378,
  x2: 0.185,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00ff94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007caf"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M-35.438-35.437A10.134,10.134,0,0,0-25.313-45.562,10.134,10.134,0,0,0-35.438-55.687,10.134,10.134,0,0,0-45.563-45.562,10.134,10.134,0,0,0-35.438-35.437Zm70.875,0A10.134,10.134,0,0,0,45.562-45.562,10.134,10.134,0,0,0,35.437-55.687,10.134,10.134,0,0,0,25.312-45.562,10.134,10.134,0,0,0,35.437-35.437ZM40.5-30.375H30.375a10.1,10.1,0,0,0-7.135,2.943A23.141,23.141,0,0,1,35.121-10.125H45.562a5.057,5.057,0,0,0,5.062-5.062V-20.25A10.134,10.134,0,0,0,40.5-30.375Zm-40.5,0A17.71,17.71,0,0,0,17.719-48.094,17.71,17.71,0,0,0,0-65.812,17.71,17.71,0,0,0-17.719-48.094,17.71,17.71,0,0,0,0-30.375Zm12.15,5.062H10.837A24.921,24.921,0,0,1,0-22.781a24.974,24.974,0,0,1-10.837-2.531H-12.15A18.23,18.23,0,0,0-30.375-7.087v4.556a7.6,7.6,0,0,0,7.594,7.594H22.781a7.6,7.6,0,0,0,7.594-7.594V-7.087A18.23,18.23,0,0,0,12.15-25.312Zm-35.39-2.12a10.1,10.1,0,0,0-7.135-2.943H-40.5A10.134,10.134,0,0,0-50.625-20.25v5.062a5.057,5.057,0,0,0,5.062,5.062h10.426A23.2,23.2,0,0,1-23.24-27.432Z",
  transform: "translate(50.625 65.812)",
  fill: "url(#linear-gradient)"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101.25,
    height: 70.875,
    viewBox: "0 0 101.25 70.875",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Profile.4fdfabe0.svg";
export { ForwardRef as ReactComponent };